import { useDispatch, useSelector } from "react-redux";
import { getSuccessMessage } from "../../state/modules/layout/selectors";
import { hideSuccessMessage } from "../../state/modules/layout/actions";

import styles from "./SuccessMessage.css";

export const SuccessMessage = () => {
  const dispatch = useDispatch();

  const { isVisible, linkText, linkUrl, message } =
    useSelector(getSuccessMessage);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.messageContainer}>
          <span className={styles.message}>{message}</span>
          <a className={styles.link} href={linkUrl}>
            {linkText}
          </a>
        </div>
        <button
          aria-label="Close"
          className={styles.closeButton}
          onClick={() => dispatch(hideSuccessMessage())}
        />
      </div>
    </div>
  );
};
